import { render, staticRenderFns } from "./CloudProductBatchEdit.vue?vue&type=template&id=684aee94&scoped=true"
import script from "./CloudProductBatchEdit.vue?vue&type=script&lang=js"
export * from "./CloudProductBatchEdit.vue?vue&type=script&lang=js"
import style0 from "./CloudProductBatchEdit.vue?vue&type=style&index=0&id=684aee94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684aee94",
  null
  
)

export default component.exports